import { IAsset } from '../asset';
import { CurrencyCode } from '@/services/finance';
import { Price } from '@/services/price';

export enum ResourceType {
  component = 'component',
  material = 'material',
}

export type IProductId = string;

export type IProductSize = string[];

export interface IProductProp {
  key: string;
  value: string;
}

export interface IProductComponentDetail {
  name: string;
  prices: Price[];
}

export interface IProductMaterialDetail {
  name: string;
  color?: string;
  composition?: string;
  weight?: string;
  prices: Price[];
}

export interface IProductResource<Detail> {
  id: string;
  index: number;
  name: string;
  qty: number;
  resource_id: string;
  detail: Detail;
}

export interface IProductResourceCost {
  currency: CurrencyCode;
  resources: {
    [resourceId: string]: number;
  };
}

export interface IProduct {
  id: IProductId;
  user_id: string;
  care_instructions: string;
  care_symbols: {
    [key: string]: string[];
  };
  name: string;
  notes: string;
  properties: IProductProp[];
  resource_costs: IProductResourceCost[];
  sizes: IProductSize[];

  // related tables/views
  assets: IAsset[];
  components: Array<IProductResource<IProductMaterialDetail>>;
  materials: Array<IProductResource<IProductMaterialDetail>>;
  costs: Price[];
  prices: Price[];
}
